// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__IFsmp","h2":"Heading_h2__MAT8c","h3":"Heading_h3__fIE5a","h4":"Heading_h4__VMrgJ"};